var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Espaco',{attrs:{"segmento":_vm.segmento}}),_c('br'),_c('Materiais',{attrs:{"segmento":_vm.segmento}}),_c('br'),_c('Seguro'),_c('br'),_c('Uniforme'),_c('br'),_c('Convenios')],1)}
var staticRenderFns = []

export { render, staticRenderFns }